import { FC, PropsWithChildren } from 'react';
import { dataTestId } from 'modules/experiments/constants';
import { VariantPillWrapper } from './Styled';

type VariantPillProps = {
  textColor: string;
  bgColor: string;
};

export const VariantPill: FC<PropsWithChildren<VariantPillProps>> = ({
  textColor,
  bgColor,
  children,
}) => {
  return (
    <VariantPillWrapper
      data-test={dataTestId.variantAlphabet}
      textColor={textColor}
      bgColor={bgColor}
    >
      {children}
    </VariantPillWrapper>
  );
};
